// apps/accounts/src/components/TopBar.jsx
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, Bell, Menu, X } from 'lucide-react';

const LOGO_URL = 'https://files.housedesigns99.com/api/files/f5eolh49d789mqi/rwth7jtsmlcst1n/house_designs99_logo_fwjsybt4i7.png';

export const TopBar = ({ onToggleSidebar, isSidebarOpen }) => {
  const { user, role, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // ড্যাশবোর্ড ট্যাবের কনফিগারেশন
  const allDashboards = [
    { id: 'main', label: '🏠 Main', path: '/dashboard/main', roles: ['admin', 'accounts'] },
    { id: 'construction', label: '🏗️ Construction', path: '/dashboard/construction', roles: ['admin', 'accounts', 'partner-construction'] },
    { id: 'interior', label: '🛋️ Interior', path: '/dashboard/interior', roles: ['admin', 'accounts', 'partner-interior'] },
  ];

  const visibleDashboards = allDashboards.filter(db => db.roles.includes(role || ''));

  const getDashboardPath = () => {
    if (role === 'admin' || role === 'accounts') return '/dashboard/main';
    if (role === 'partner-construction') return '/dashboard/construction';
    if (role === 'partner-interior') return '/dashboard/interior';
    return '/dashboard/main';
  };

  // ড্রপডাউন পরিবর্তনে নেভিগেট
  const handleSelectChange = (e) => {
    navigate(e.target.value);
  };

  return (
    <header className="bg-white shadow-sm px-4 py-3 flex items-center justify-between border-b border-slate-200 sticky top-0 z-50">
      {/* Left section: Logo + Hamburger */}
      <div className="flex items-center gap-3">
        {/* হ্যামবার্গার – শুধু মোবাইলে */}
        <button
          className="lg:hidden p-2 rounded-md hover:bg-slate-100 transition"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <Link to={getDashboardPath()} className="flex items-center gap-2 hover:opacity-80 transition">
          <img src={LOGO_URL} alt="Qudexa" className="w-8 h-8 rounded-lg object-contain" />
          <span className="text-xl font-bold text-slate-800 whitespace-nowrap">
            Accounts <span className="text-amber-500">Panel</span>
          </span>
        </Link>
      </div>

      {/* Middle: Dashboard Tabs – Desktop */}
      <nav className="hidden lg:flex items-center gap-1 bg-slate-50 p-1 rounded-lg">
        {visibleDashboards.map((db) => {
          const isActive = location.pathname === db.path;
          return (
            <Link
              key={db.id}
              to={db.path}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                isActive 
                  ? 'bg-amber-500 text-white shadow-md shadow-amber-200' 
                  : 'text-slate-600 hover:bg-slate-200'
              }`}
            >
              {db.label}
            </Link>
          );
        })}
      </nav>

      {/* Middle: Mobile Dropdown */}
      <div className="lg:hidden flex-1 mx-3">
        <select
          value={location.pathname}
          onChange={handleSelectChange}
          className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400"
        >
          {visibleDashboards.map((db) => (
            <option key={db.id} value={db.path}>
              {db.label.replace(/[🏠🏗️🛋️]/g, '').trim()}
            </option>
          ))}
        </select>
      </div>

      {/* Right: User Profile & Actions */}
      <div className="flex items-center gap-3 flex-shrink-0">
        <button className="p-2 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100 transition">
          <Bell className="w-5 h-5" />
        </button>
        <span className="text-sm font-medium text-slate-700 hidden sm:inline">
          {user?.name || 'User'}
        </span>
        <span className="text-xs bg-slate-200 text-slate-600 px-2.5 py-1 rounded-full font-medium hidden sm:inline">
          {role || 'guest'}
        </span>
        <button
          onClick={logout}
          className="text-slate-400 hover:text-red-500 transition text-sm px-2 py-1 hover:bg-red-50 rounded-lg"
        >
          <LogOut className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
};